import React from "react";
// import Progress from "../Progress";
import SubmitButton from "../../Buttons/SubmitButton";
import BackIconWhite from "../../../assets/images/BackIconWhite.svg";
import loginEnvMap from "../../../config.js";

export const SomethingWrongUpgrade = () => {
  const handleLogin = () => {
    const env = (window.env || "").toLowerCase();
    const apiUrl = process.env.REACT_APP_API_URL;
    const loginUrl = apiUrl ? `${apiUrl}/saml/login` : "/api/saml/login";
    window.location.href = loginEnvMap[env] || loginUrl;
  };
  return (
    <>
      <div className="intro">
        {/* <Progress progress={40} /> */}
        <h1 className="intro-title-mi" lang="mi-NZ">
          Auē, kua mau mātou e whakahou ana i te pūnaha
        </h1>
        <hr />
        <h1 className="intro-title">
          Oops, you've caught us upgrading our system
        </h1>

        <div className="step-container">
          <p className="mb-4">
            We're migrating our data to a new system, and your verified identity
            is currently unavailable. Please try again in a few days.
          </p>
        </div>
        <div className="step-button-container">
          <SubmitButton
            text={"Back to RealMe"}
            onClick={handleLogin}
            Icon={BackIconWhite}
          />
        </div>
      </div>
    </>
  );
};

export default SomethingWrongUpgrade;
